import axios, { isCancel } from 'axios';
import { toast } from 'react-toastify';

const { REACT_APP_API_VERSION, REACT_APP_API_BASE_URL } = process.env;

const api = axios.create({
  baseURL: `${REACT_APP_API_BASE_URL}/${REACT_APP_API_VERSION}`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response || isCancel(error)) {
      return;
    }
    // Server responded with a status code out of 2xx range
    const statusCode = error.response.status;
    if (statusCode === 401 && window.location.pathname !== '/signin') {
      toast.error('Unauthorized, Please Login', { toastId: 'unauthorized' });
      localStorage.clear();
      window.location.replace('/signin');
    }

    // Optionally, return a rejected promise to ensure `.catch` is triggered in individual requests
    return Promise.reject(error);
  }
);

export default api;
